import { BaseService } from "../../../global/classes";
import { bffApi } from "../../../services/bff/bffApi";
import { createHTMLElement, downloadFile } from "../../../utils/downloadFiles";

export default class PaymentStatementServices extends BaseService {
  getPayments = async (
    page: number,
    pageSize: number,
    filter?: any
  )=> {
    const merchantId = this.selectedCompany?.merchantId ?? filter?.merchantId ?? null;
    const rangeStartReceiveDate = filter?.rangeStartReceiveDate || null;
    const rangeEndReceiveDate = filter?.rangeEndReceiveDate || null;
    const paymentType = filter?.paymentType || null;
    const brandCode = filter?.brandCode || null;

    try {
      const result = await bffApi.get(`/api/slc/v1/paymentdetail/payment-details`,
        {
          params: {
            merchantId: merchantId,
            rangeStartReceiveDate: rangeStartReceiveDate,
            rangeEndReceiveDate: rangeEndReceiveDate,
            paymentType: paymentType,
            brandCode: brandCode,
            pageNumber: page,
            pageSize: pageSize,
            format: "json"
          },
        });

      return result.data;
    } catch (error) {
      throw error;
    }
  };

  getPaymentsXlsxDownload = async (
    type: string,
    filter?: any
  ) => {
    const merchantId = this.selectedCompany?.merchantId ?? filter?.merchantId ?? null;
    const rangeStartReceiveDate = filter?.rangeStartReceiveDate || null;
    const rangeEndReceiveDate = filter?.rangeEndReceiveDate || null;
    const paymentType = filter?.paymentType || null;
    const brandCode = filter?.brandCode || null;

    try {
      const result = await bffApi.get(`/api/slc/v1/paymentdetail/payment-details`,
        {
          params: {
            format: "xlsx",
            merchantId: merchantId,
            rangeStartReceiveDate: rangeStartReceiveDate,
            rangeEndReceiveDate: rangeEndReceiveDate,
            paymentType: paymentType,
            brandCode: brandCode,
          },
          responseType: "blob"
        });

      const htmlElement = createHTMLElement(result.data);
      const fileName = 'Extrato';
      downloadFile(htmlElement, fileName, type);
    } catch (error) {
      throw error;
    }
  }
}
